module.exports = __webpack_public_path__ + "static/media/c.213afd23.png";